import { Component } from '@angular/core';

@Component({
  selector: 'itl-modal-page',
  templateUrl: 'modal-page.component.html',
  styleUrls: ['modal-page.component.scss'],
})
export class ModalPageComponent {}
